import navigation, { topNavigation } from './navigation';
import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';
import Webpush from '../pages/profile/webpush/Webpush.vue';

export default {
  data() {
    return { loadingSettings: false };
  },
  components: {
    Drawer,
    Header,
    Webpush,
    Footer,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    authLayout() {
      return !this.isAuthenticated
        && ['login', 'register', 'remind', 'login-external'].includes(this.$route.name);
    },
    showWebpushPopup() {
      return 'Notification' in window
        && this.$store.state.user
        && this.$store.state.settings.webpush === true
        && this.$store.state.webpush.webpushPopupOpened === true
        && this.$store.state.webpush.webpushFirebaseToken === null
        && this.$store.state.webpush.webpushDeclinedAt === null;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    menuItems() {
      return navigation(this.$store.state.user, this.$store.state.settings, this.isAuthenticated);
    },
    topMenuItems() {
      return topNavigation(
        this.$store.state.user, this.$store.state.settings, this.isAuthenticated,
      );
    },
    settingsReady() {
      return this.$store.state.settingsReady;
    },
  },
  watch: {
    isAuthenticated(authenticated, previous) {
      if (previous && !authenticated && this.$route.path !== '/') this.$router.replace('/');
    },
    '$route.path': function closeMenu() { this.$store.dispatch('app/SetSidebar', false); },
    settingsReady(value) {
      if (value && this.isBannersOn) this.loadBanners();
    },
  },
  methods: {
    reloadSettings() {
      this.loadingSettings = true;
      return this.$store.dispatch('GetSettings')
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => { this.loadingSettings = false; });
    },
    reloadProfile() {
      return this.$store.dispatch('GetProfile')
        .catch(error => this.$store.dispatch('HandleError', error));
    },
    loadBanners() {
      // The action displays the API error; consume its rejection here.
      return this.$store.dispatch('banners/GetBannersList').catch(() => {});
    },
  },
  created() {
    this.$store.dispatch('app/SetSidebar', false);
    this.$store.commit('SetSettingsReady', false);
    this.reloadSettings();
  },
};
